"use client";
import SvgBilholdSymbol from "./bilhold_symbol.svg.js";
import SvgBilholdWordmark from "./bilhold_wordmark.svg.js";
const bilhold = {
  key: "bilhold",
  symbol: SvgBilholdSymbol,
  wordmark: SvgBilholdWordmark
};
export {
  bilhold
};
